import { render, staticRenderFns } from "./settingMenu.vue?vue&type=template&id=5cf1f069&scoped=true"
import script from "./settingMenu.vue?vue&type=script&lang=js"
export * from "./settingMenu.vue?vue&type=script&lang=js"
import style0 from "./settingMenu.vue?vue&type=style&index=0&id=5cf1f069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1f069",
  null
  
)

export default component.exports